module.exports = __webpack_public_path__ + "static/media/train_2.6ea6b265.png";